import React, { useState, useRef, useEffect } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { BasicDetailItem } from '../../common/BasicDetailItem';
import { CustomCardHeader } from '../../common/custom-card-header/CustomCardHeader';
import { ProfileEdit } from './profile-edit/ProfileEdit';
import './profile.scss';
import { awsBucket, BucketCredentials } from '../../../services/API/core';
import { Typography } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import { LinkButton } from '../../common/LinkButton';
import { formatPhoneNumber } from '../../../helpers/utils';
import '../../common/custom-card-header/customCardheader.scss';
import avatarIcon from '../../../assets/images/avatar.svg';

const ProfileDetailReadyOnly = ({ profile, onClickEdit }) => (
  <div
    className='d-flex flex-direction-column align-items-center'
    style={{ flexDirection: 'column' }}
  >
    <BasicDetailItem
      isBold
      dataClassName={'text-uppercase'}
      value={`${profile?.first_name ?? ''} ${profile?.last_name ?? ''}`}
    />
    {/* <BasicDetailItem value={profile?.university ?? ''} /> */}

    <BasicDetailItem
      value={profile?.email?.toLowerCase() ?? ''}
      makeFirstCharCapital={false}
    />
    <BasicDetailItem value={formatPhoneNumber(profile?.phone ?? '')} />
    <LinkButton
      className={'mt-3'}
      onClick={() => {
        if (onClickEdit) {
          onClickEdit();
        }
      }}
    >
      <span className='actionLabelText'>Edit</span>
    </LinkButton>
  </div>
);

const UPDATE_PROF_DETAILS = 'update_profile_details';

export const Profile = ({
  profileData,
  handleDataChange,
  updatingParts,
  handleCancelUpdate,
}) => {
  const upload = useRef(null);

  const [isEditingMode, setIsEditingMode] = useState(false);
  const [profileImage, setProfileImage] = useState(
    profileData.profile_image_url || null
  );
  const [image, setImage] = useState(null);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const isSM = windowWidth <= 600;
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);

  const isUpdating = updatingParts[UPDATE_PROF_DETAILS];

  const hanldeUpdateProfileUpdate = async (newValues) => {
    const uploadUrl = await handleUpload(image);
    let newDataToSend = {
      ...newValues,
    };
    if (newDataToSend?.email) {
      newDataToSend = {
        ...newDataToSend,
        email: newDataToSend.email?.toLowerCase(),
      };
    }
    if (uploadUrl) {
      newDataToSend = {
        ...newDataToSend,
        profile_image_url: uploadUrl,
      };
    }
    handleDataChange(UPDATE_PROF_DETAILS, newDataToSend, () => {
      setIsEditingMode(false);
    });
  };

  const handleCancel = (e) => {
    if (isUpdating) {
      handleCancelUpdate(UPDATE_PROF_DETAILS);
    }
    setProfileImage(profileData.profile_image_url || null);
    setIsEditingMode(false);
  };

  const handleUpload = async (fileObj) => {
    if (fileObj && fileObj.file) {
      let fileParts = fileObj.file.name.split('.');
      let fileName = fileParts[0];
      let fileType = fileObj.file.type;
      const randUid = uuid();
      const params = {
        ACL: 'public-read',
        Key: `upload_files/${fileName}${randUid}`,
        ContentType: fileType,
        Body: fileObj.file,
      };
      await awsBucket
        .putObject(params)
        .on('httpUploadProgress', (evt) => {})
        .send((err) => {
          if (err) {
            console.log(err);
          }
        });
      const uploadUrl = await awsBucket.getSignedUrlPromise('getObject', {
        Bucket: BucketCredentials.bucketName,
        Key: `upload_files/${fileName}${randUid}`,
      });
      return uploadUrl.split('?')[0];
    } else {
      return '';
    }
  };

  const generatePreviewData = (file) => {
    const fr = new FileReader();
    return new Promise((resolve, reject) => {
      fr.addEventListener('load', (e) => {
        let res = fr.result;
        resolve({ uri: res, file: file });
      });
      fr.addEventListener('error', (e) => {
        reject();
      });
      fr.readAsDataURL(file);
    });
  };

  const onChangeFile = ({ target }) => {
    if (target.files.length > 0) {
      const res = generatePreviewData(target.files[0]);
      res.then((img) => {
        setImage(img);
        setProfileImage(img.uri);
      });
    }
  };

  return (
    <Card
      className='no-shadow'
      style={{
        border: `1px solid #2E2B2B`,
        backgroundColor: '#F5E5D9',
        width: '100%',
        marginRight: isSM ? 12 : windowWidth <= 900 ? 0 : 12,
        marginLeft: isSM ? 12 : 0,
      }}
    >
      {/* <CustomCardHeader
        title='profile'
        actionBtnLabel={isEditingMode ? 'Close' : 'Edit'}
        handleActionBtnClick={handleEditCancelToggle}
      /> */}
      <CardBody>
        <div
          className='profile-data-wrpper'
          style={
            isSM
              ? {
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflowX: 'auto',
                }
              : {}
          }
        >
          <div
            className='pp-wrapper'
            onClick={() => {
              if (isEditingMode) {
                upload.current.click();
              }
            }}
          >
            <input
              ref={upload}
              name='file_uploads'
              type='file'
              style={{ display: 'none' }}
              id='file_uploads'
              accept='image/*'
              value=''
              onChange={onChangeFile}
            />
            <img
              src={
                profileImage && profileImage !== '' ? profileImage : avatarIcon
              }
              loading={'lazy'}
              alt=''
              resizeMode={'contain'}
              style={{ height: 200, width: 200, borderRadius: 100 }}
            />
            {isEditingMode ? (
              <Typography
                style={{
                  textAlign: 'center',
                  fontSize: '0.9rem',
                  fontFamily: 'Brown',
                  cursor: 'pointer',
                }}
              >
                Click on the photo to change it. Make sure your image is square
                in size before uploading.
              </Typography>
            ) : null}
          </div>

          <div className='pp-details' style={isSM ? { overflowX: 'auto' } : {}}>
            {isEditingMode ? (
              <ProfileEdit
                profile={profileData}
                isUpdating={isUpdating}
                onSubmit={hanldeUpdateProfileUpdate}
                onClickCancel={() => handleCancel()}
              />
            ) : (
              <ProfileDetailReadyOnly
                profile={profileData}
                onClickEdit={() => setIsEditingMode(true)}
              />
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
